const ITEMS = [
  "Reece",
  "Cass Brothers",
  "ABI Interiors",
  "Caroma",
  "Phoenix",
  "Nero Tapware",
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="brand-marquee"
      className="border-y border-[#27272A] bg-[#080A0B] py-8 overflow-hidden"
    >
      <div className="flex items-center gap-4 mb-6 px-6 md:px-12 lg:px-16">
        <span className="block w-8 h-px bg-[#3FB8DC]" />
        <span className="eyebrow">Trade partners we work with</span>
      </div>
      <div className="overflow-hidden">
        <div className="marquee-track flex gap-16 whitespace-nowrap">
          {loop.map((item, i) => (
            <span
              key={i}
              className="font-serif-display text-3xl md:text-5xl italic text-[#F4F0EB]/40 hover:text-[#3FB8DC] transition-colors"
            >
              {item}
              <span className="ml-16 text-[#3FB8DC]/40">◆</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
